import img1 from '../images/event-listing-image-2.jpg'

function BallsSystem() {
	return (
		<>
	<section class="hero_area bs_area" style={{background:`URL(${img1})`}}>
		<div class="container">
			<div class="hero_cnt">
				<div class="hero_title">
					<h2>Balls System</h2>
					<h1> Understanding the Balls System in TravelHellasPlayGR</h1>
					<p>Welcome to the Balls System page of TravelHellasPlayGR! This section explains our unique scoring mechanism that adds excitement and strategy to your fantasy cricket experience.</p>
					<h2> What is the Balls System?</h2>
					<p>The Balls System is a scoring framework designed to reward players based on their performances in real-life matches. In this system, each player earns points for various actions during a match, giving you the opportunity to maximize your fantasy team’s potential.</p>
				</div>
			</div>
		</div>
	</section>

	<section class="sec_2_bs">
		<div class="container">
			<div class="sec_2_bs_table">
				<table>
					<thead>
						<tr>
							<th>Event</th>
							<th>Points</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Featured in the Playing XI</td>
							<td>4</td>
						</tr>
						<tr>
							<td>Captain Points</td>
							<td>2X</td>
						</tr>
						<tr>
							<td>Vice-Captain Points</td>
							<td>1.5X</td>
						</tr>
						<tr>
							<td>Batting Points</td>
							<td></td>
						</tr>
						<tr>
							<td>Every Run Scored</td>
							<td>1</td>
						</tr>
						<tr>
							<td>Every Boundary Hit</td>
							<td>1</td>
						</tr>
						<tr>
							<td>Every Six Hit</td>
							<td>2</td>
						</tr>
						<tr>
							<td>30 Run Bonus</td>
							<td>4</td>
						</tr>
						<tr>
							<td>Half Century Bonus</td>
							<td>8</td>
						</tr>
						<tr>
							<td>Century Bonus</td>
							<td>16</td>
						</tr>
						<tr>
							<td>Double Century Bonus</td>
							<td>32</td>
						</tr>
						<tr>
							<td>Dismissal for a Duck (Except Bowlers)</td>
							<td>-2</td>
						</tr>
						<tr>
							<td>Bowling Points</td>
							<td></td>
						</tr>
						<tr>
							<td>Every Wicket Taken (excluding run out)</td>
							<td>25</td>
						</tr>
						<tr>
							<td>For Every LBW & Bowled Dismissal</td>
							<td>8</td>
						</tr>
						<tr>
							<td>3-Wicket Haul Bonus</td>
							<td>4</td>
						</tr>
						<tr>
							<td>4-Wicket Haul Bonus</td>
							<td>8</td>
						</tr>
						<tr>
							<td>5-Wicket Haul Bonus</td>
							<td>16</td>
						</tr>
						<tr>
							<td>Maiden Over</td>
							<td>12</td>
						</tr>
						<tr>
							<td>Strike Rate & Economy Rate Points</td>
							<td></td>
						</tr>
						<tr>
							<td>Strike Rate Over 170</td>
							<td>6</td>
						</tr>
						<tr>
							<td>Strike Rate Between 150.01 to 170</td>
							<td>4</td>
						</tr>
						<tr>
							<td>Strike Rate Between 130 to 150</td>
							<td>2</td>
						</tr>
						<tr>
							<td>Strike Rate Between 60 to 70</td>
							<td>-2</td>
						</tr>
						<tr>
							<td>Strike Rate Between 50 to 59.99</td>
							<td>-4</td>
						</tr>
						<tr>
							<td>Strike Rate Less than 50</td>
							<td>-6</td>
						</tr>
						<tr>
							<td>Note: Minimum balls faced: 10<br/>
								Strike Rate Points not valid for Bowlers</td>
							<td></td>
						</tr>
						<tr>
							<td>Economy Rate Less than 5</td>
							<td>6</td>
						</tr>
						<tr>
							<td>Economy Rate Between 5 to 5.99</td>
							<td>4</td>
						</tr>
						<tr>
							<td>Economy Rate Between 6 to 7</td>
							<td>2</td>
						</tr>
						<tr>
							<td>Economy Rate Between 10 to 11</td>
							<td>-2</td>
						</tr>
						<tr>
							<td>Economy Rate Over Between 11.01 to 12</td>
							<td>-4</td>
						</tr>
						<tr>
							<td>Economy Rate Over 12</td>
							<td>-6</td>
						</tr>

					</tbody>
				</table>
			</div>
		</div>
	</section>

		</>
	)
}

export default BallsSystem
